import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || "en";

  const set = (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem("nyoksure_lang", lng); } catch {}
  };

  if (compact) {
    return (
      <div
        className="inline-flex items-center gap-1 rounded-full bg-white border border-[#114232]/10 p-0.5 text-[11px] font-semibold uppercase tracking-wider"
        data-testid="lang-switcher"
      >
        {["en", "sw"].map((lng) => (
          <button
            key={lng}
            onClick={() => set(lng)}
            data-testid={`lang-${lng}`}
            className={`px-2 py-1 rounded-full transition-colors ${
              current === lng
                ? "bg-[#114232] text-[#f4f2eb]"
                : "text-[#5c6360] hover:text-[#114232]"
            }`}
          >
            {lng}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-2 px-2 py-1.5 rounded-md bg-white border border-[#114232]/10"
      data-testid="lang-switcher"
    >
      <Languages className="w-3.5 h-3.5 text-[#5c6360]" strokeWidth={1.5} />
      {["en", "sw"].map((lng) => (
        <button
          key={lng}
          onClick={() => set(lng)}
          data-testid={`lang-${lng}`}
          className={`text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded transition-colors ${
            current === lng
              ? "bg-[#114232] text-[#f4f2eb]"
              : "text-[#5c6360] hover:text-[#114232]"
          }`}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
